import React, { useState } from "react";

import { Dialog, Grid, Typography } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

import { ImageInput, useNotify, FormDataConsumer } from "react-admin";
import { useForm } from "react-final-form";

import { MAX_PHOTO_SIZE, MAX_PHOTO_SIZE_MSG } from "../../../utils/constants";
import { AttachPhotoIcon } from "../../../components/common/iconography";
import { ImageField } from "../../../components/common/ImageField";

const useStyles = makeStyles((theme) => ({
  boolean: {
    marginTop: theme.spacing(1),
  },
  mediaFull: {
    margin: "0 auto 0",
    width: "auto",
    maxWidth: "100%",
    height: "auto",
    borderRadius: "6px",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
  },
}));

const BrandingPanel = ({ disabled, ...props }) => {
  if (disabled) return <BrandingShow {...props} />;
  return <BrandingForm {...props} />;
};

const BrandingForm = ({ record, ...props }) => {
  const classes = useStyles();
  const form = useForm();
  const notify = useNotify();
  const [magnifiedUrl, setMagnifiedUrl] = useState();

  const handleImageChange = (value, source) => {
    debugger;
    if (!value) {
      form.change(source, null);
    } else if (value?.size > MAX_PHOTO_SIZE) {
      form.change(source, null);
      notify(MAX_PHOTO_SIZE_MSG, "warning");
    }
  };

  const handleMagnifyPhoto = (event) => {
    if (!magnifiedUrl) setMagnifiedUrl(event.target.lowsrc);
    else setMagnifiedUrl(null);
  };

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12}>
            <ImageInput
              source="logoImage"
              label="BUSINESS LOGO"
              accept="image/bmp,image/png,image/jpeg,image/jpg,image/gif,image/svg+xml"
              variant="outlined"
              fullWidth
              placeholder={
                <p>
                  <AttachPhotoIcon fontSize="large" />
                  <br />
                  Drop your logo image here, or click to select it
                </p>
              }
              onChange={(value) => handleImageChange(value, "logoImage")}
            >
              <ImageField
                source="src"
                title="Business Logo"
                thumbWidth={250}
                thumbHeight={200}
                scaleThumb={true}
                fullSize={window.innerWidth}
                onClick={handleMagnifyPhoto}
              />
            </ImageInput>
          </Grid>
          {magnifiedUrl ? (
            <Dialog
              open={magnifiedUrl}
              maxWidth="lg"
              onClick={handleMagnifyPhoto}
            >
              <img
                src={magnifiedUrl}
                alt="Business Logo"
                className={classes.mediaFull}
                onClick={handleMagnifyPhoto}
              />
            </Dialog>
          ) : null}
        </Grid>
      )}
    </FormDataConsumer>
  );
};

const BrandingShow = ({ record, ...props }) => {
  const classes = useStyles();
  const [magnifiedUrl, setMagnifiedUrl] = useState();

  const handleMagnifyPhoto = (event) => {
    if (!magnifiedUrl) setMagnifiedUrl(event.target.lowsrc);
    else setMagnifiedUrl(null);
  };

  return (
    <Grid container direction="row" justifyContent="center" spacing={4}>
      {/* <Grid item xs={12} >
                <Typography variant="body2" color="default">Reply To address: {getReplyToAddress(record)}</Typography>
            </Grid> */}
      <Grid item xs={12}>
        <Typography variant="overline" color="textSecondary" gutterBottom>
          BUSINESS LOGO
        </Typography>
        <ImageField
          source="logoImage"
          label="Business Logo"
          thumbWidth={250}
          thumbHeight={200}
          scaleThumb={true}
          fullSize={window.innerWidth}
          onClick={handleMagnifyPhoto}
        />
      </Grid>
      {magnifiedUrl ? (
        <Dialog open={magnifiedUrl} maxWidth="lg" onClick={handleMagnifyPhoto}>
          <img
            src={magnifiedUrl}
            alt="Business Logo"
            className={classes.mediaFull}
            onClick={handleMagnifyPhoto}
          />
        </Dialog>
      ) : null}
    </Grid>
  );
};

export default BrandingPanel;
